import * as types from '../actiontypes';

export const setContactDBFilter = (filterItemName, value) => {
	return {
		type: types.SET_CONTACTSDB_FILTER,
		filterItemName,
		value
	};
};

export const clearContactDBFilters = () => {
	return {
		type: types.CLEAR_CONTACTSDB_FILTER
	};
};
